import { ScrollToTop } from "components/common/functions"
import PropTypes from "prop-types"
import React, { Fragment } from "react"
import { AnimatedSwitch } from "react-router-transition"
import {
  fadeInOutBounceMapStyles,
  makeFadeInOutBounce,
  useExtension
} from "utils"

const fadeInFadeOutBounce = makeFadeInOutBounce(100, 22)

const RouteWrapper = ({ children }) => {
  return (
    <AnimatedSwitch
      atEnter={fadeInFadeOutBounce.atEnter}
      atActive={fadeInFadeOutBounce.atActive}
      atLeave={fadeInFadeOutBounce.atLeave}
      mapStyles={fadeInOutBounceMapStyles}
      className="route-wrapper"
    >
      {children}
    </AnimatedSwitch>
  )
}

RouteWrapper.propTypes = {
  children: PropTypes.node
}

export default function AppRoutes() {
  const { modules: extensionModules } = useExtension()
  const { routes: extensionRoutes } = extensionModules
  // const { config } = useExtension()
  // const { keycloak, initialized } = useKeycloak()
  // const [loginBaseURL] = React.useState(config?.env?.oktaConfig?.url);
  // if (loginBaseURL === undefined) throw new Error("Cannot retrieve login url.");
  return (
    <>
      <RouteWrapper>
        {/* <Route
          exact
          path="/login"
          render={() => <Login baseUrl={loginBaseURL} />}
        /> */}
        {/* <Route exact path="/login/callback" component={LoginCallback} /> */}
        {/* <Route exact path="/logout" render={(keycloak) => keycloak?.logout()}  /> */}
        <Fragment>
          <ScrollToTop />
          {extensionRoutes}
        </Fragment>
        {/* <Route component={pages.Page404} /> */}
      </RouteWrapper>
    </>
  )
}
